(function() {

  angular
	.module('meanApp')
	.controller('measuresCtrl', measuresCtrl);

  measuresCtrl.$inject = ['$location', 'measuresManager','Measure',  '$rootScope', 'alert', '$scope', 'confirmationModal'];
  function measuresCtrl($location, measuresManager, Measure, $rootScope, alert, $scope, confirmationModal) {
	var vm = this;
	//console.log('the current user is ', $rootScope.currentUser);
	vm.measures = {};

	$rootScope.$watch('currentUser', function () {
		if ($rootScope.currentUser) {
			if($rootScope.currentUser.role === 'admin'){
				loadMeasures();
			}
			else {
				$location.path('/');
			}
		}
	}, function(err) {
		console.log(err);
	});

	var loadMeasures = function() {
		measuresManager.getAll()
		.then(function(result) {
			vm.measures = result.collection;
		}, function(err) {
			console.log('error loafing all measures');
		});
	};

	vm.confirmationQuestion = 'Voulez vous vraiment supprimer cette mesure ?';
	vm.onConfirmationModalClick = function() {
		measuresManager.delete($scope.measureIDToDelete)
		.then(function() {
			this.$close();
	  		alert.push('success', 'Cette mesure a été supprimée définitivement de la base de données');
	  	}.bind($scope), function() {
	  		this.$close();
	  		alert.push('danger', "Cette mesure n'a pas pu être supprimée");
	  	}.bind($scope));

	};
	
	vm.removeMeasure = function(id) {
		$scope.measureIDToDelete = id;
		$scope.modalInstance = confirmationModal.open($scope, 'measuresCtrl');
	};

	vm.onMeasureSubmit = function() {
		if (typeof vm.id !== 'undefined' && vm.name) {
			
			var newMeasure = new Measure({
				easyID: vm.id,
				name: vm.name
			});
			newMeasure.save()
			.then(function (measure) {
				var instanceMeasure = measuresManager.set(measure);
				vm.measures.push(instanceMeasure);
				alert.push('success', 'Nouvelle mesure ajoutée en base de données');
			}, function (error) {
				//TOOD préciser si déja en base de données ou quoi
				alert.push('danger', 'Mesure non ajoutée en base de données');
			});
		}
	};

  }

})();